var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _vm.favorites.length || _vm.showFavoriteNameModal
        ? _c(
            "w-col",
            { attrs: { md: "12" } },
            [
              _vm.favorites.length
                ? _c("w-select", {
                    attrs: {
                      value: _vm.selectedFavoriteId,
                      items: _vm.favoriteItems,
                      label: _vm.$ct("favorites.label"),
                      fancy: "",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.applyFavorite($event)
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "w-modal",
                {
                  attrs: { value: _vm.showFavoriteNameModal },
                  on: {
                    input: function ($event) {
                      _vm.showFavoriteNameModal = $event
                    },
                  },
                },
                [
                  _c(
                    "w-card",
                    { attrs: { "max-width": "500" } },
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("favorites.label"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("favorites.name"),
                              fancy: "",
                              autofocus: "",
                            },
                            on: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.confirmSaveFavorite()
                              },
                            },
                            model: {
                              value: _vm.favoriteName,
                              callback: function ($$v) {
                                _vm.favoriteName = $$v
                              },
                              expression: "favoriteName",
                            },
                          }),
                          _vm.favorites.length
                            ? _c(
                                "w-list",
                                _vm._l(_vm.favorites, function (favorite) {
                                  return _c(
                                    "w-list-item",
                                    { key: favorite.ID },
                                    [
                                      _c("w-list-item-text", [
                                        _vm._v(_vm._s(favorite.Name)),
                                      ]),
                                      _c(
                                        "w-list-item-action",
                                        [
                                          _c(
                                            "w-link",
                                            {
                                              directives: [
                                                {
                                                  name: "tooltip",
                                                  rawName: "v-tooltip",
                                                  value:
                                                    _vm.$ct("favorites.delete"),
                                                  expression:
                                                    "$ct('favorites.delete')",
                                                },
                                              ],
                                              staticClass:
                                                "favorite-delete-link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteFavorite(
                                                    favorite
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "trash" },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel",
                              attrs: { icon: "ban" },
                              on: {
                                click: function ($event) {
                                  _vm.showFavoriteNameModal = false
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              attrs: {
                                disabled:
                                  !_vm.favoriteName.trim() ||
                                  _vm.savingFavorite,
                                icon: "check",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmSaveFavorite()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("common.save")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("app-select-bank-type", {
            attrs: { fancy: "", "use-ids": "" },
            model: {
              value: _vm.bank.TypeID,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "TypeID", $$v)
              },
              expression: "bank.TypeID",
            },
          }),
          _vm.balances.length > 0
            ? _c("div", { staticClass: "current-balance" }, [
                _vm._v(
                  _vm._s(_vm.$ct("current-bank-balance")) +
                    _vm._s(_vm.currentBalance)
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("w-input", {
            attrs: { label: _vm.$ct("labels.stnr"), fancy: "", autofocus: "" },
            model: {
              value: _vm.bank.StNr,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "StNr", $$v)
              },
              expression: "bank.StNr",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-date-picker", {
            attrs: {
              "min-date": _vm.bookYearStartDate,
              "max-date": _vm.bookYearEndDate,
              "has-error": !_vm.isDateValid,
              label: _vm.$ct("labels.TimeCreated"),
              fancy: "",
              locale: _vm.locale,
            },
            model: {
              value: _vm.bank.TimeCreated,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "TimeCreated", $$v)
              },
              expression: "bank.TimeCreated",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { md: "12" } },
        [
          _c("app-select-bank-kind", {
            attrs: {
              label: _vm.$ct("labels.kind"),
              fancy: "",
              value: _vm.bank.Kind,
            },
            on: {
              input: function ($event) {
                return _vm.onBankKindInput($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        [
          _c("app-ledger-account-autocomplete", {
            attrs: {
              value: _vm.bank.LedgerAccountCode,
              disabled: _vm.disableLedgerInput,
              fancy: "",
              label: _vm.$ct("labels.DefaultLedgerAccountCode"),
            },
            on: {
              input: function ($event) {
                return _vm.onLedgerAccountCode($event)
              },
            },
          }),
        ],
        1
      ),
      _vm.batch.length == 0
        ? _c(
            "w-col",
            { attrs: { md: "12", "no-margin": "" } },
            [
              _c(
                "w-row",
                [
                  _vm.bank.Kind == 2
                    ? _c(
                        "w-col",
                        { attrs: { md: "12" } },
                        [
                          _c("app-sale-search", {
                            attrs: {
                              label: _vm.$ct("labels.invoice"),
                              fancy: "",
                              multiple:
                                (!_vm.bank.ID ||
                                  (_vm.originalBank.Kind == 1 &&
                                    !_vm.originalBank.Invoice)) &&
                                _vm.multiple,
                              value: _vm.bank.Invoice,
                              bank: _vm.originalBank,
                            },
                            on: {
                              batch: function ($event) {
                                return _vm.selectSales($event)
                              },
                              input: function ($event) {
                                return _vm.selectSale($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.bank.Kind == 3
                    ? _c(
                        "w-col",
                        { attrs: { md: "12" } },
                        [
                          _c("app-purchase-search", {
                            attrs: {
                              label: _vm.$ct("labels.purchase"),
                              fancy: "",
                              value: _vm.bank.Purchase,
                              multiple:
                                (!_vm.bank.ID ||
                                  (_vm.originalBank.Kind == 1 &&
                                    !_vm.originalBank.Purchase)) &&
                                _vm.multiple,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.selectPurchase($event)
                              },
                              batch: function ($event) {
                                return _vm.selectPurchases($event)
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "w-col",
                    { attrs: { md: "12" } },
                    [
                      _c("app-contact-search", {
                        attrs: {
                          label: _vm.$ct("labels.contact"),
                          fancy: "",
                          value: _vm.bank.Contact,
                          "group-id": _vm.selectableContactGroups,
                          "disable-create": "",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.selectContact($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "w-col",
            [
              _c(
                "w-card",
                [
                  _c(
                    "w-card-content",
                    { style: { padding: 0 } },
                    [
                      _c("app-custom-table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [
                              _vm._v(_vm._s(_vm.$ct("open-columns.number"))),
                            ]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$ct("open-columns.name"))),
                            ]),
                            _c("th", [
                              _vm._v(_vm._s(_vm.$ct("open-columns.open"))),
                            ]),
                            _c("th"),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.batch, function (sale, i) {
                            return _c("tr", { key: i }, [
                              _c("td", [
                                _vm._v(_vm._s(sale.ComputedFriendlyID)),
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getBatchCompanyName(sale))),
                              ]),
                              _c("td", [
                                _vm._v(_vm._s(_vm.getBatchTotalOpen(sale))),
                              ]),
                              _c("td"),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.originalBank.ID &&
              _vm.bank.TotalDC != _vm.originalBank.TotalDC
                ? _c(
                    "div",
                    [
                      _c("w-info", {
                        attrs: {
                          "ico-lib": "fas",
                          ico: "info-circle",
                          text:
                            "Geboekt verschil van EUR " + _vm.bankDifference,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
      _c(
        "w-col",
        {
          style: { display: "flex", flexDirection: "row" },
          attrs: { md: "12" },
        },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.debet
                    ? _vm.$ct("labels.debet-amount")
                    : _vm.$ct("labels.credit-amount"),
                  expression:
                    "debet ? $ct('labels.debet-amount') : $ct('labels.credit-amount')",
                },
              ],
              staticClass: "dc-switch",
              style: {
                height: "100%",
                marginRight: "8px",
                marginBottom: "2px",
                fontSize: "18px",
                width: "35px",
              },
              attrs: { disabled: _vm.bank.Kind != 1 },
              on: {
                click: function ($event) {
                  return _vm.onDebetCreditToggle()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.debet ? "+" : "-") + " ")]
          ),
          _c("w-input-number", {
            ref: "total",
            style: { flexGrow: 1 },
            attrs: {
              label: _vm.$ct("labels.amount"),
              fancy: "",
              icon: _vm.showDc ? "chevron-down" : "chevron-up",
              negative: true,
              disabled: _vm.disableTotal,
            },
            on: {
              "icon-click": function ($event) {
                _vm.showDc = !_vm.showDc
              },
              blur: function ($event) {
                return _vm.switchTotalDc()
              },
            },
            model: {
              value: _vm.bank.Total,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "Total", $$v)
              },
              expression: "bank.Total",
            },
          }),
        ],
        1
      ),
      _c("w-col", [
        _vm.balances.length > 0
          ? _c("div", { staticClass: "current-balance" }, [
              _vm._v(
                _vm._s(_vm.$ct("new-bank-balance")) + _vm._s(_vm.newBalance)
              ),
            ])
          : _vm._e(),
      ]),
      _vm.showDc
        ? _c(
            "w-col",
            { attrs: { md: "12" } },
            [
              _c("w-input-number", {
                attrs: {
                  label: _vm.$ct("labels.amount-dc"),
                  fancy: "",
                  negative: true,
                  disabled: _vm.disableTotal,
                },
                model: {
                  value: _vm.bank.TotalDC,
                  callback: function ($$v) {
                    _vm.$set(_vm.bank, "TotalDC", $$v)
                  },
                  expression: "bank.TotalDC",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-textarea-autogrow", {
            attrs: { label: _vm.$ct("labels.info"), fancy: "" },
            model: {
              value: _vm.bank.Info,
              callback: function ($$v) {
                _vm.$set(_vm.bank, "Info", $$v)
              },
              expression: "bank.Info",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }